module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap-no"
  }, [_vm._v("ABOUT THIS BOOK")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Take a few stitches through layers of top fabric, some padding and backing fabric and there you go – you’re a quilter! Quilting can be a little daunting for many people who are imagining bed-sized quilts, but quilting can be much simpler than this – you can make something as small as an egg cosy and quilt it.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In this book, I’d like to introduce you to a selection of different quilting techniques (both hand-sewn and machine-sewn), explain the difference between patchwork and quilting (although a lot of the time they go hand in hand) and hopefully give you lots of ideas and inspiration through projects you’ll find easy to make, but you could re-work and add to if you’re a more experienced sewer.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The main thing I’d like to instil in you is the confidence to have a go. Every award-winning quilter started in the same place as you: they made their first cut in their fabric, they sewed their first stitch and they made their first mistake. They are award-winning because they carried on. I’m not suggesting you must head towards competition level! But nobody is born with the ability to sew. You need only to try, practise and enjoy! So go choose your fabric and let’s get started!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a297ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Frontmatter02.vue
// module id = 75
// module chunks = 0